import { Link } from "react-router-dom";
import heroImage from "../../assets/litigation-hero.jpg";

function Litigation() {
  return (
    <>
      {/* ================= HERO ================= */}
      <section className="relative h-[80vh] flex items-center justify-center pt-24">

        {/* BACKGROUND IMAGE */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${heroImage})`,
          }}
        ></div>

        {/* OVERLAY */}
        <div className="absolute inset-0 bg-black/60"></div>

        {/* CONTENT */}
        <div className="relative z-10 text-center text-white px-6 max-w-3xl">
          <h1 className="text-4xl md:text-6xl font-dancing-script">
            Litigation & Dispute Resolution
          </h1>

          <p className="mt-4 text-lg text-gray-200">
            
          </p>
        </div>

      </section>

     
     {/* ================= CONTENT ================= */}
<section className="py-20 px-6 bg-white">
  <div className="max-w-4xl mx-auto text-center">

    <p className="text-gray-700 text-lg leading-relaxed">
  Litigation and dispute resolution practice at <strong>GATI & CO. ADVOCATES</strong> is built on strategic advocacy, precision, and decisive action.
  Guided by our philosophy of <span className="italic">“Turning conflict into closure,”</span>
  we represent individuals, businesses, and institutions in resolving disputes
  efficiently while safeguarding their rights, interests, and long-term objectives.
</p>

<p className="mt-6 text-gray-700 text-lg leading-relaxed">
  Our civil litigation services cover contract breaches, tort claims,
  debt recovery, damages, and complex commercial disputes.
  We also handle constitutional petitions involving human rights enforcement
  and violations of the Bill of Rights, as well as land and environment matters
  including boundary disputes, compulsory acquisition, and environmental torts.
  In employment law, we represent clients in cases involving wrongful dismissal,
  unfair termination, and collective bargaining agreement interpretation.
</p>

<p className="mt-6 text-gray-700 text-lg leading-relaxed">
  Beyond courtroom litigation, we provide alternative dispute resolution services
  through arbitration and mediation, offering clients private and binding
  mechanisms for resolving disputes without unnecessary court delays.
  Our firm also undertakes judicial review proceedings to challenge unlawful
  decisions made by public bodies, tribunals, and local authorities.
  Every matter is approached with careful preparation, strategic foresight,
  and a commitment to achieving practical and sustainable outcomes.
</p>

  </div>
</section>

      {/* ================= NAV BUTTONS ================= */}
<section className="py-12 px-6 bg-gray-100 border-t border-gray-200">
  <div className="max-w-7xl mx-auto flex justify-between items-center">

    {/* LEFT BUTTON */}
    <Link
      to="/services"
      className="px-6 py-3 border-2 border-[#0B3D91] text-[#0B3D91] bg-white rounded-lg font-semibold hover:bg-[#0B3D91] hover:text-white transition hover:-translate-x-1"
    >
      ← Back to Practice Areas
    </Link>

    {/* RIGHT BUTTON */}
    <Link
      to="/services/conveyancing"
      className="px-6 py-3 bg-[#0B3D91] text-white rounded-lg font-semibold hover:bg-blue-800 transition hover:translate-x-1"
    >
      Next Area →
    </Link>

  </div>
</section>
    </>
  );
}

export default Litigation;